<template>
<div class='setting-wrapper'>
  <setting-infos />
  <setting-form />
</div>
</template>

<script>
import SettingForm from './form/'
import SettingInfos from './infos/'

export default {
  components: {
    'setting-form': SettingForm,
    'setting-infos': SettingInfos
  }
}
</script>

<style lang='scss' scoped>
.setting-wrapper {
    // upload image
    width: $page-width-small;
    margin: 0 auto;
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// index.vue?5739aaf8